/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { richtextToText, quillToTipTapJson } from "cms/rich-text/simplicity-composer-tiptap/rich-text-utils";
import { isRichTextQuill } from "cms/rich-text/simplicity-composer-tiptap/use-rich-text-to-html";
import { isValidGuid } from "utils/empty-exists";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { formatBytes } from "utils/format-bytes";
import { Logger } from "cms/utils/log/logger";

function capitalizeInitial (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
const getRichtext = async (richtext) => {
    const isQuill = isRichTextQuill(richtext);
    const json = isQuill ? quillToTipTapJson(richtext) : richtext;
    return json ? richtextToText(json) : "";
};
const getLink = async (guid, token) => {
    let link;
    if (isValidGuid(guid)) {
        link = await SimpliCityAdminSDK.link.findOne(token, guid);
    }
    return link;
};
const getImage = async (guid, token) => {
    return SimpliCityAdminSDK.images.findOne(token, guid);
};
// eslint-disable-next-line no-unused-vars
const getDocument = async (guid, token) => {
    let doc;
    if (isValidGuid(guid)) {
        doc = await SimpliCityAdminSDK.documents.findOne(token, guid);
    }
    return doc;
};
const buildSample = async (component, token) => {
    try {
        Logger.debug("sample", component);
        const { type } = component || {};
        const displayType = capitalizeInitial(type.replace("component.", ""));
        
        if (type === "component.rich-text") {
            const { richtext } = component;
            return getRichtext(richtext);
            
        } else if (type === "component.rich-text-editor") {
            const { richtext } = component;
            return getRichtext(richtext);
                
        } else if (type === "component.rich-text-with-image") {
            const { richtext } = component;
            // const {richtext, image: _image} = component
            // const image = await getImage(component, token)
            return getRichtext(richtext);
            
        } else if (type === "component.heading") {
            const { value } = component;
            return value;
            
        } else if (type === "component.info-box") {
            const { richtext } = component;
            return getRichtext(richtext);
            
        } else if (type === "component.image") {
            const { image: guid } = component;
            if (isValidGuid(guid)) {
                const image = await getImage(guid, token);
                const { file_name, alt, file_size } = image || {};
                const size = formatBytes(file_size);
                return `${alt} [${size}] [${file_name}]`;
            } else {
                return "";
            }
        } else if (type === "component.image-gallery") {
            // const {title, description, image_gallery} = component
            const { title, description } = component;
            const richtextSample = await getRichtext(description);
            // const images = []
            // image_gallery.forEach((image) => {
            //     images.push(image.file_name)
            // })
            return `${title} ${richtextSample}`;
            
        } else if (type === "component.image-list") {
            const { title, description } = component;
            const richtextSample = await getRichtext(description);
            return `${title} ${richtextSample}`;
            
        } else if (type === "component.youtube") {
            const { title, src, srcid } = component;
            return `${title} ${srcid} ${src}`;
            
        } else if (type === "component.accordion") {
            const { title, sections } = component;
            const titles = [];
            sections.forEach((section) => {
                titles.push(section.title);
            });
            return `${title} ${titles.join(", ")}`;
            
        } else if (type === "component.tab-panel") {
            const { tabs } = component;
            const tab_titles = [];
            tabs.forEach((tab) => {
                tab_titles.push(tab.title);
            });
            return `${tab_titles.join(", ")}`;
            
        } else if (type === "component.table") {
            return "";
            
        } else if (type === "component.feature-webpage") {
            const { description, webpages } = component;
            const richtextSample = await getRichtext(description);
            const titles = [];
            webpages.forEach((webpage) => {
                titles.push(webpage.title);
            });
            return `${richtextSample} ${titles.join(", ")}`;
            
        } else if (type === "component.document-list") {
            const { title } = component;
            return title;
            
        } else if (type === "component.links-list") {
            const { title } = component;
            return title;
            
        } else if (type === "component.link-button") {
            const { link: guid } = component;
            const link = await getLink(guid, token);
            const { text, url } = link;
            return `${text}: [${url}]`;
            
        } else if (type === "component.call-to-action") {
            // const {description, image} = component
            const { description } = component;
            const richtextSample = await getRichtext(description);
            return `${richtextSample}`;
            
        } else if (type === "component.table-of-contents") {
            const { description } = component;
            const richtextSample = await getRichtext(description);
            return `${richtextSample}`;
            
        } else if (type === "component.form") {
            const { title } = component;
            // get form?
            return title;
            
        } else if (type === "component.feedback") {
            const { primary_question } = component;
            return primary_question;
            
        } else if (type === "component.embed") {
            const { html } = component;
            return html;
            
        } else if (type === "component.magic" || type === "MAGIC") {
            return "Magic is something you create.";
            
        } else {
            return `${type} ${displayType}`;
            
        }
    } catch (error) {
        Logger.error(error);
    }
};

export {
    buildSample
};

